import React from 'react';

import Marketplace from './components/Marketplace';

class App extends React.Component {
  render() {
    return <Marketplace />;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js